import { getXmlDate, parseXmlDate2 } from '../../utility/date.helpers';
import { paramDate, paramDay } from './constants/parameterNames';
import { typeDropDown } from './constants/parameterTypes';
import { failure, success } from './helpers/commandResult';
import { getParamValue } from './helpers/parameter.accessors';

const optionalParameters = [
    {
        name: paramDate,
        description: 'Date for the week. If omitted, the current date is used.',
    },
];

const requiredParameters = [
    {
        name: paramDay,
        description:
            'Day of the week to get. Assumes a Sunday - Saturday week.',
        type: typeDropDown,
        options: [
            {
                name: 'Monday',
                value: 'mo',
            },
            {
                name: 'Tuesday',
                value: 'tu',
            },
            {
                name: 'Wednesday',
                value: 'we',
            },
            {
                name: 'Thursday',
                value: 'th',
            },
            {
                name: 'Friday',
                value: 'fr',
            },
            {
                name: 'Saturday',
                value: 'sa',
            },
            {
                name: 'Sunday',
                value: 'su',
            },
        ],
    },
];

const getWeekdayErrorInvalidDay =
    'Invalid day parameter -- please use either a complete day name or two letter abbreviation';
const getWeekdayErrorUnableToParseDate = 'Unable to parse date';

const description =
    'Returns the date of a specific weekday within a given week.';

function getDayOfWeek(day) {
    switch (day.toLowerCase()) {
        case 'monday':
        case 'mo':
            return 1;

        case 'tuesday':
        case 'tu':
            return 2;

        case 'wednesday':
        case 'we':
            return 3;

        case 'thursday':
        case 'th':
            return 4;

        case 'friday':
        case 'fr':
            return 5;

        case 'saturday':
        case 'sa':
            return 6;

        case 'sunday':
        case 'su':
            return 0;

        default:
            return -1;
    }
}

function validateAndParseDate(date) {
    var parseDate = parseXmlDate2(date, { mode: 'utc' });

    if (!parseDate) {
        throw new Error(`${getWeekdayErrorUnableToParseDate}: ${date}`);
    }

    return parseDate.date;
}

function calculateWeekDay(date, dayOfWeek) {
    const dateValue = date ? validateAndParseDate(date) : new Date();
    const diff = dateValue.getUTCDay() - dayOfWeek;

    const newDateValue = new Date(dateValue);
    newDateValue.setUTCDate(newDateValue.getUTCDate() - diff);

    const resultDate = getXmlDate(newDateValue, { mode: 'utc' });

    return success(resultDate);
}

function execute({ parameters }) {
    const date = getParamValue(parameters, paramDate);
    const day = getParamValue(parameters, paramDay);
    const dayOfWeek = getDayOfWeek(day);

    if (dayOfWeek < 0) {
        return failure(getWeekdayErrorInvalidDay);
    }

    return calculateWeekDay(date, dayOfWeek);
}

const GetWeekDay = {
    description,
    optionalParameters,
    requiredParameters,
    execute,
};

export default GetWeekDay;
